<!-- API开发文档页面 -->
<template>
  <div :class="['api-doc-container', `theme-${currentTheme}`]">
    <!-- 头部区域 -->
    <header class="api-header">
      <h1>API 开发文档</h1>
    </header>

    <!-- 主体内容：左右分栏布局 -->
    <div class="api-layout">
      <!-- 左侧菜单栏 -->
      <aside class="sidebar">
        <ul class="nav-list">
          <!-- 协议规则导航链接 -->
          <li><a href="#protocol" @click.prevent="scrollTo('protocol')">协议规则</a></li>

          <!-- API接口列表导航链接 -->
          <li><a href="#api-list" @click.prevent="scrollTo('api-list')">API 接口列表</a></li>
          <!-- SDK下载导航链接 -->
          <li><a href="#download-sdk" @click.prevent="scrollTo('download-sdk')">SDK下载</a></li>

          <!-- 新增：公共查询数据（无需Token） -->
          <li><a href="#public-query" @click.prevent="scrollTo('public-query')">公共查询数据</a></li>
          <!-- 新增：查询作品统计数据（官方API） -->
          <li><a href="#public-statistics" @click.prevent="scrollTo('public-statistics')">查询作品统计数据</a></li>
          <!-- 新增：获取用户余额 -->
          <li><a href="#user-balance" @click.prevent="scrollTo('user-balance')">获取用户余额</a></li>
        </ul>
      </aside>

      <!-- 右侧内容区 -->
      <main class="content">
        <!-- 协议规则部分 -->
        <section id="protocol" class="section">
          <h2>协议规则</h2>
          <ul class="rules-list">
            <!-- 请求数据格式说明 -->
            <li><strong>请求数据格式：</strong>application/x-www-form-urlencoded   或者json</li>
            <!-- 返回数据格式说明 -->
            <li><strong>返回数据格式：</strong>JSON</li>
            <!-- 签名算法说明 -->
            <li><strong>签名算法：</strong>MD5</li>
            <!-- 字符编码说明 -->
            <li><strong>字符编码：</strong>UTF-8</li>
          </ul>
        </section>

        <!-- 测试账号部分 -->
        <section id="test-account" class="section">

          <div class="notes">
            <!-- 测试账号使用说明 -->
            <p><strong>说明：</strong></p>
            <ol>
              <!-- 测试金额建议 -->
              <li>api统一地址为:http://113.44.37.234:8000</li>
              <!-- 退款说明 -->
              <li>如客服不在，请自行注册账号，并使用账号登录，然后使用邮箱传递参数即可查询数据。</li>
              <!-- 测试账号使用限制 -->
              <li>测试api请联系客服索要测试</li>
              <!-- 接口使用说明 -->
              <li>请勿使用本平台进行非法业务<span style="color: red; font-weight: bold;">【如网络水军,刷单,引流推广,黄赌毒】</span>。如有违规行为，请立即停止使用本平台。</li>
            </ol>
          </div>
        </section>



        <!-- 新增：查询作品数据（/api/query/douyin） -->
<!--        <section id="douyin-query" class="section">
          <h2>1. 查询作品数据(需要 Token令牌)</h2>
          <p><strong>接口地址：</strong><code>/api/query/douyin</code></p>
          <p><strong>请求方式：</strong>POST</p>
          <p><strong>是否需要 Token：</strong><span class="token-status token-required">需 Token</span></p>
          &lt;!&ndash; 新增：请求头说明 &ndash;&gt;
          <div class="notes">
            <h3>请求头（Headers）</h3>
            <table class="header-table">
              <thead>
              <tr>
                <th>字段名</th>
                <th>类型</th>
                <th>必填</th>
                <th>示例值</th>
                <th>描述</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td>Authorization</td>
                <td>String</td>
                <td>是</td>
                <td>Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9...</td>
                <td>JWT 认证令牌，格式为 Bearer + token</td>
              </tr>
              <tr>
                <td>Content-Type</td>
                <td>String</td>
                <td>是</td>
                <td>application/json</td>
                <td>请求体数据格式，必须为 JSON</td>
              </tr>
              </tbody>
            </table>
          </div>
          <table class="param-table">
            <thead>
            <tr>
              <th>字段名</th>
              <th>类型</th>
              <th>必填</th>
              <th>示例值</th>
              <th>描述</th>

            </tr>
            </thead>
            <tbody>
            <tr>
              <td>items</td>
              <td>Array[String]</td>
              <td>是</td>
              <td>["7523965230288817449", "7234567890123456789"]</td>
              <td>待查询的视频 ID 列表</td>

            </tr>
            <tr>
              <td>user_email</td>
              <td>String</td>
              <td>是</td>
              <td>example@domain.com</td>
              <td>用户邮箱</td>
            </tr>
            <tr>
              <td>include_play</td>
              <td>Boolean</td>
              <td>否</td>
              <td>true</td>
              <td>是否包含播放量，默认为 true</td>
            </tr>
            </tbody>
          </table>
        </section>-->

        <!-- 新增：公共查询数据（/api/query/publicQueryDouyinData） -->
        <section id="public-query" class="section">
          <h2>1. 公共查询数据(无需 Token令牌)</h2>
          <p><strong>接口地址：</strong><code>/api/query/publicQueryDouyinData</code></p>
          <p><strong>请求方式：</strong>POST</p>
          <p><strong>是否需要 Token：</strong>否</p>
          <p><strong>说明：</strong>查询短视频作品的详细信息，包括标题、封面、作者信息、播放量、点赞、评论、分享等全量数据。支持批量查询。</p>
          <table class="param-table">
            <thead>
            <tr>
              <th>字段名</th>
              <th>类型</th>
              <th>必填</th>
              <th>示例值</th>
              <th>描述</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>items</td>
              <td>Array[String]</td>
              <td>是</td>
              <td>["7523965230288817449", "7234567890123456789"]</td>
              <td>待查询的视频 ID 列表</td>
            </tr>
            <tr>
              <td>include_play</td>
              <td>Boolean</td>
              <td>否</td>
              <td>true</td>
              <td>是否包含播放量，默认为 true</td>
            </tr>
            <tr>
              <td>user_email</td>
              <td>String</td>
              <td>是</td>
              <td>example@domain.com</td>
              <td>用户邮箱</td>
            </tr>
            <tr>
              <td>password</td>
              <td>String</td>
              <td>是</td>
              <td>12345678</td>
              <td>密码</td>
            </tr>
            </tbody>
          </table>

          <h3>返回字段说明</h3>
          <table class="param-table">
            <thead>
            <tr>
              <th>字段名</th>
              <th>类型</th>
              <th>描述</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>aweme_id</td>
              <td>String</td>
              <td>作品 ID</td>
            </tr>
            <tr>
              <td>status</td>
              <td>String</td>
              <td>查询状态：success / failed</td>
            </tr>
            <tr>
              <td>owner_nickname</td>
              <td>String</td>
              <td>作者昵称</td>
            </tr>
            <tr>
              <td>owner_handle</td>
              <td>String</td>
              <td>平台账号</td>
            </tr>
            <tr>
              <td>desc</td>
              <td>String</td>
              <td>作品描述</td>
            </tr>
            <tr>
              <td>play_count</td>
              <td>Number</td>
              <td>播放量</td>
            </tr>
            <tr>
              <td>digg_count</td>
              <td>Number</td>
              <td>点赞数</td>
            </tr>
            <tr>
              <td>comment_count</td>
              <td>Number</td>
              <td>评论数</td>
            </tr>
            <tr>
              <td>share_count</td>
              <td>Number</td>
              <td>分享数</td>
            </tr>
            <tr>
              <td>collect_count</td>
              <td>Number</td>
              <td>收藏数</td>
            </tr>
            <tr>
              <td>duration</td>
              <td>Number</td>
              <td>视频时长（秒）</td>
            </tr>
            <tr>
              <td>create_time</td>
              <td>String</td>
              <td>发布时间</td>
            </tr>
            <tr>
              <td>download_url</td>
              <td>String</td>
              <td>无水印下载地址</td>
            </tr>
            <tr>
              <td>engagement_rate</td>
              <td>Number</td>
              <td>互动率</td>
            </tr>
            </tbody>
          </table>

          <h3>请求示例（Python）</h3>
          <pre style="background:#16213e;color:#e2e8f0;padding:15px;border-radius:6px;overflow-x:auto;font-size:13px;"><code>import requests

url = "http://113.44.37.234:8000/api/query/publicQueryDouyinData"
payload = {
    "user_email": "your_email@qq.com",
    "password": "your_password",
    "items": ["7523965230288817449"],
    "include_play": True
}
resp = requests.post(url, json=payload)
print(resp.json())</code></pre>

          <h3>返回示例</h3>
          <pre style="background:#16213e;color:#e2e8f0;padding:15px;border-radius:6px;overflow-x:auto;font-size:13px;"><code>{
  "code": 200,
  "data": {
    "count": 1,
    "success_count": 1,
    "error_count": 0,
    "new_balance": 100,
    "results": [
      {
        "aweme_id": "7523965230288817449",
        "status": "success",
        "owner_nickname": "作者昵称",
        "owner_handle": "douyin_id",
        "desc": "作品描述",
        "play_count": 100000,
        "digg_count": 5000,
        "comment_count": 200,
        "share_count": 100,
        "collect_count": 300,
        "duration": 30,
        "create_time": "2024-01-01 12:00:00",
        "download_url": "https://...",
        "engagement_rate": 0.062
      }
    ],
    "status": "success"
  }
}</code></pre>

          <div class="notes">
            <p><strong>注意：</strong></p>
            <ol>
              <li>每次成功查询消耗 1 点余额（非 VIP 用户），失败不扣费。</li>
              <li>VIP 用户不扣余额，但计入每日查询次数限制。</li>
              <li>支持批量查询，一次可传入多个作品 ID，效率更高。</li>
              <li>返回的下载链接有时效性，请尽快使用。</li>
            </ol>
          </div>
        </section>

        <!-- 新增：查询作品统计数据（官方API，无需 Token） -->
        <section id="public-statistics" class="section">
          <h2>2. 查询作品统计数据(无需 Token令牌)</h2>
          <p><strong>接口地址：</strong><code>/api/query/publicQueryDouyinStatistics</code></p>
          <p><strong>请求方式：</strong>POST</p>
          <p><strong>是否需要 Token：</strong>否</p>
          <p><strong>说明：</strong>调用短视频官方统计 API（<code>api-hl.amemv.com</code>），批量获取作品的播放量、点赞数、评论数、分享量等统计数据。只返回 API 实际存在的字段，没有的字段不会返回。</p>
          <table class="param-table">
            <thead>
            <tr>
              <th>字段名</th>
              <th>类型</th>
              <th>必填</th>
              <th>示例值</th>
              <th>描述</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>items</td>
              <td>Array[String]</td>
              <td>是</td>
              <td>["7659981508056312305", "7651938261178289459"]</td>
              <td>待查询的作品 ID 列表</td>
            </tr>
            <tr>
              <td>user_email</td>
              <td>String</td>
              <td>是</td>
              <td>example@domain.com</td>
              <td>用户邮箱</td>
            </tr>
            <tr>
              <td>password</td>
              <td>String</td>
              <td>是</td>
              <td>12345678</td>
              <td>用户密码</td>
            </tr>
            <tr>
              <td>include_play</td>
              <td>Boolean</td>
              <td>否</td>
              <td>true</td>
              <td>是否包含播放量，默认为 true</td>
            </tr>
            </tbody>
          </table>

          <h3>返回字段说明</h3>
          <table class="param-table">
            <thead>
            <tr>
              <th>字段名</th>
              <th>类型</th>
              <th>描述</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>aweme_id</td>
              <td>String</td>
              <td>作品 ID</td>
            </tr>
            <tr>
              <td>status</td>
              <td>String</td>
              <td>查询状态：success / failed</td>
            </tr>
            <tr>
              <td>play_count</td>
              <td>Number</td>
              <td>播放量（API 返回则包含，不返回则不包含）</td>
            </tr>
            <tr>
              <td>digg_count</td>
              <td>Number</td>
              <td>点赞数</td>
            </tr>
            <tr>
              <td>comment_count</td>
              <td>Number</td>
              <td>评论数</td>
            </tr>
            <tr>
              <td>share_count</td>
              <td>Number</td>
              <td>分享数</td>
            </tr>
            <tr>
              <td>collect_count</td>
              <td>Number</td>
              <td>收藏数</td>
            </tr>
            <tr>
              <td>download_count</td>
              <td>Number</td>
              <td>下载数</td>
            </tr>
            <tr>
              <td>forward_count</td>
              <td>Number</td>
              <td>转发数</td>
            </tr>
            <tr>
              <td>lose_count</td>
              <td>Number</td>
              <td>丢失数</td>
            </tr>
            <tr>
              <td>lose_comment_count</td>
              <td>Number</td>
              <td>评论丢失数</td>
            </tr>
            </tbody>
          </table>

          <h3>请求示例（Python）</h3>
          <pre style="background:#16213e;color:#e2e8f0;padding:15px;border-radius:6px;overflow-x:auto;font-size:13px;"><code>import requests

url = "http://113.44.37.234:8000/api/query/publicQueryDouyinStatistics"
payload = {
    "user_email": "your_email@qq.com",
    "password": "your_password",
    "items": ["7659981508056312305"],
    "include_play": True
}
resp = requests.post(url, json=payload)
print(resp.json())</code></pre>

          <h3>返回示例</h3>
          <pre style="background:#16213e;color:#e2e8f0;padding:15px;border-radius:6px;overflow-x:auto;font-size:13px;"><code>{
  "code": 200,
  "data": {
    "count": 1,
    "success_count": 1,
    "error_count": 0,
    "new_balance": 100,
    "results": [
      {
        "aweme_id": "7659981508056312305",
        "status": "success",
        "digg_count": 183,
        "play_count": 68930,
        "share_count": 1
      }
    ],
    "status": "success"
  }
}</code></pre>

          <div class="notes">
            <p><strong>注意：</strong></p>
            <ol>
              <li>该接口调用短视频官方统计 API，只返回实际存在的字段，不会出现默认值 0。</li>
              <li>每次成功查询消耗 1 点余额（非 VIP 用户），失败不扣费。</li>
              <li>VIP 用户不扣余额，但计入每日查询次数限制。</li>
              <li>支持批量查询，一次可传入多个作品 ID。</li>
            </ol>
          </div>
        </section>

        <!-- 新增：获取用户余额（/api/user/balance） -->
        <section id="user-balance" class="section">
          <h2>3. 获取用户余额(需要 Token令牌)</h2>
          <p><strong>接口地址：</strong><code>/api/user/balance</code></p>
          <p><strong>请求方式：</strong>POST</p>

          <p><strong>是否需要 Token：</strong><span class="token-status token-required">需 Token</span></p>
          <!-- 新增：请求头说明 -->
          <div class="notes">
            <h3>请求头（Headers）</h3>
            <table class="header-table">
              <thead>
              <tr>
                <th>字段名</th>
                <th>类型</th>
                <th>必填</th>
                <th>示例值</th>
                <th>描述</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td>Authorization</td>
                <td>String</td>
                <td>是</td>
                <td>Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9...</td>
                <td>JWT 认证令牌，格式为 Bearer + token</td>
              </tr>
              <tr>
                <td>Content-Type</td>
                <td>String</td>
                <td>是</td>
                <td>application/json</td>
                <td>请求体数据格式，必须为 JSON</td>
              </tr>
              </tbody>
            </table>
          </div>
          <p><strong>说明：</strong>获取当前账号的剩余点数余额。需要先通过登录接口获取 Token 令牌。</p>
          <table class="param-table">
            <thead>
            <tr>
              <th>字段名</th>
              <th>类型</th>
              <th>必填</th>
              <th>示例值</th>
              <th>描述</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>user_email</td>
              <td>String</td>
              <td>是</td>
              <td>example@domain.com</td>
              <td>用户邮箱</td>
            </tr>
            </tbody>
          </table>

          <h3>返回字段说明</h3>
          <table class="param-table">
            <thead>
            <tr>
              <th>字段名</th>
              <th>类型</th>
              <th>描述</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>code</td>
              <td>Number</td>
              <td>状态码：200=成功</td>
            </tr>
            <tr>
              <td>data.balance</td>
              <td>Number</td>
              <td>当前剩余点数余额</td>
            </tr>
            <tr>
              <td>data.user_email</td>
              <td>String</td>
              <td>用户邮箱</td>
            </tr>
            <tr>
              <td>data.is_vip</td>
              <td>Boolean</td>
              <td>是否 VIP 用户</td>
            </tr>
            <tr>
              <td>data.vip_type</td>
              <td>String</td>
              <td>VIP 类型：super_vip / normal_vip / none</td>
            </tr>
            <tr>
              <td>data.vip_expiry</td>
              <td>String</td>
              <td>VIP 到期时间（如有）</td>
            </tr>
            </tbody>
          </table>

          <h3>请求示例（Python）</h3>
          <pre style="background:#16213e;color:#e2e8f0;padding:15px;border-radius:6px;overflow-x:auto;font-size:13px;"><code>import requests

url = "http://113.44.37.234:8000/api/user/balance"
headers = {
    "Authorization": "Bearer YOUR_TOKEN_HERE",
    "Content-Type": "application/json"
}
payload = {
    "user_email": "your_email@qq.com"
}
resp = requests.post(url, headers=headers, json=payload)
print(resp.json())</code></pre>

          <h3>返回示例</h3>
          <pre style="background:#16213e;color:#e2e8f0;padding:15px;border-radius:6px;overflow-x:auto;font-size:13px;"><code>{
  "code": 200,
  "data": {
    "balance": 150,
    "user_email": "example@domain.com",
    "is_vip": true,
    "vip_type": "normal_vip",
    "vip_expiry": "2026-12-31 23:59:59"
  }
}</code></pre>

          <div class="notes">
            <p><strong>注意：</strong></p>
            <ol>
              <li>需要先调用登录接口获取 Token 令牌，并在请求头中带上 <code>Authorization: Bearer YOUR_TOKEN</code>。</li>
              <li>余额单位是"点"，每次查询作品消耗 1 点。</li>
              <li>VIP 用户不扣余额，但计入每日查询次数限制。</li>
              <li>如需充值，请联系客服或通过支付宝/微信支付。</li>
            </ol>
          </div>
        </section>

        <!-- SDK下载部分 -->
        <section id="download-sdk" class="section">
          <h2>SDK下载</h2>
          <p>请下载最新版本 SDK：<a href="/downloads/sdk-v1.0.zip" download="sdk-v1.0.zip">点击这里下载</a></p>
        </section>
      </main>
    </div>

    <!-- 底部版权信息 -->
    <footer class="api-footer">
      <p>© 2026 抖数君 | 保留所有权利</p>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'Doc',
  data() {
    return {
      currentTheme: 'starry' // 默认星空主题
    };
  },
  mounted() {
    // 设置网页标题为"API文档"
    document.title = 'API文档';

    // 从 localStorage 读取保存的主题
    const savedTheme = localStorage.getItem('currentTheme');
    if (savedTheme) {
      this.currentTheme = savedTheme;
    }
    // 将主题应用到 body 全局背景
    this.applyBodyTheme(this.currentTheme);

    // 监听主题切换事件（由 TiktokQuery 等页面触发）
    this._handleThemeChanged = (e) => {
      if (e.detail && e.detail.theme) {
        this.currentTheme = e.detail.theme;
        this.applyBodyTheme(e.detail.theme);
      }
    };
    window.addEventListener('theme-changed', this._handleThemeChanged);
  },
  beforeDestroy() {
    if (this._handleThemeChanged) {
      window.removeEventListener('theme-changed', this._handleThemeChanged);
    }
    // 离开页面时清理 body 主题
    document.body.className = '';
    document.body.style.background = '';
  },
  methods: {
    /**
     * 将主题应用到 body 全局背景
     */
    applyBodyTheme(theme) {
      document.body.className = `theme-${theme}`;
      // 直接设置 body 背景色，绕过 scoped CSS 限制
      const bgMap = {
        'default': '#f5f7fa',
        'starry': 'linear-gradient(135deg, #0f0f1a 0%, #1a1a2e 100%)',
        'blue': 'linear-gradient(135deg, #E3F2FD 0%, #BBDEFB 100%)',
        'purple': 'linear-gradient(135deg, #F3E5F5 0%, #E1BEE7 100%)',
        'green': 'linear-gradient(135deg, #E8F5E9 0%, #C8E6C9 100%)',
        'red': 'linear-gradient(135deg, #FFEBEE 0%, #FFCDD2 100%)',
        'orange': 'linear-gradient(135deg, #FFF3E0 0%, #FFE0B2 100%)'
      };
      document.body.style.background = bgMap[theme] || bgMap['starry'];
      document.body.style.minHeight = '100vh';
    },
    /**
     * 滚动到指定锚点
     * @param {string} id - 要滚动到的元素ID
     */
    scrollTo(id) {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }
}
</script>

<style scoped>
/* ==================== 基础样式（CSS 变量驱动） ==================== */
.api-doc-container {
  font-family: 'Microsoft YaHei', Arial, sans-serif;
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
  min-height: 100vh;
  transition: background 0.3s ease, color 0.3s ease;
}

/* 头部样式 */
.api-header {
  text-align: center;
  margin-bottom: 30px;
  padding: 24px 0;
  border-radius: 8px;
  transition: background 0.3s ease;
}

.api-header h1 {
  font-size: 28px;
  margin: 0;
  transition: color 0.3s ease;
}

/* 左右分栏布局 */
.api-layout {
  display: flex;
  gap: 20px;
  margin-bottom: 30px;
}

/* 侧边栏样式 */
.sidebar {
  width: 200px;
  border-radius: 8px;
  padding: 15px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  overflow-y: auto;
  max-height: calc(100vh - 100px);
  transition: background 0.3s ease, border-color 0.3s ease;
}

/* 导航列表样式 */
.nav-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.nav-list li {
  margin: 8px 0;
}

.nav-list a {
  text-decoration: none;
  font-size: 14px;
  transition: color 0.3s;
}

.nav-list a:hover {
  opacity: 0.8;
}

/* 内容区域样式 */
.content {
  flex: 1;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  transition: background 0.3s ease, border-color 0.3s ease;
}

/* 部分样式 */
.section {
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 1px solid;
  transition: border-color 0.3s ease;
}

.section:last-child {
  border-bottom: none;
}

.section h2 {
  margin-top: 0;
  padding-bottom: 10px;
  transition: color 0.3s ease, border-color 0.3s ease;
}

/* 规则列表样式 */
.rules-list {
  list-style: none;
  padding-left: 0;
}

.rules-list li {
  margin: 8px 0;
  padding-left: 20px;
  position: relative;
}

.rules-list li::before {
  content: "•";
  position: absolute;
  left: 0;
}

/* 测试账号样式 */
.test-account {
  margin: 15px 0;
  padding: 10px;
  border-radius: 5px;
  transition: background 0.3s ease;
}

.key-link {
  text-decoration: underline;
  cursor: pointer;
}

/* 说明样式 */
.notes {
  margin-top: 15px;
  padding: 10px;
  border: 1px dashed;
  border-radius: 5px;
  transition: background 0.3s ease, border-color 0.3s ease;
}

.notes ol {
  margin: 10px 0;
  padding-left: 20px;
}

/* API列表样式 */
.api-list {
  margin-top: 20px;
}

.api-item {
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 1px solid;
  transition: border-color 0.3s ease;
}

.api-item:last-child {
  border-bottom: none;
}

.api-item h3 {
  margin-top: 0;
}

/* 参数表格样式 */
.param-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
  max-width: 100%;
  overflow-x: auto;
}

.param-table th,
.param-table td {
  border: 1px solid;
  padding: 8px;
  text-align: left;
  transition: background 0.3s ease, border-color 0.3s ease;
}

.param-table th {
  font-weight: bold;
}

/* 底部版权样式 */
.api-footer {
  text-align: center;
  font-size: 12px;
  margin-top: 50px;
  padding: 20px;
  border-top: 1px solid;
  transition: color 0.3s ease, border-color 0.3s ease, background 0.3s ease;
}

/* 响应式设计：移动端隐藏侧边栏 */
@media (max-width: 768px) {
  .api-layout {
    flex-direction: column;
  }

  .sidebar {
    width: 100%;
    order: 2;
  }

  .content {
    order: 1;
  }
}

/* 请求头表格样式 */
.header-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 15px;
  max-width: 100%;
  overflow-x: auto;
}

.header-table th,
.header-table td {
  border: 1px solid;
  padding: 8px;
  text-align: left;
  transition: background 0.3s ease, border-color 0.3s ease;
}

.header-table th {
  font-weight: bold;
}

code {
  transition: background 0.3s ease, color 0.3s ease;
}

/* ==================== 经典主题 (default) ==================== */
.theme-default.api-doc-container {
  background: #f5f7fa;
  color: #333;
}

.theme-default .api-header {
  background: #ffffff;
  border: 1px solid #e8eaec;
}

.theme-default .api-header h1 {
  color: #333;
}

.theme-default .sidebar {
  background: #ffffff !important;
  border: 1px solid #e8eaec;
}

.theme-default .nav-list a {
  color: #333;
}

.theme-default .nav-list a:hover {
  color: #0056b3;
}

.theme-default .content {
  background: #ffffff !important;
  border: 1px solid #e8eaec;
}

.theme-default .section {
  border-bottom-color: #e8eaec;
}

.theme-default .section h2 {
  color: #1a1a1a;
  border-bottom: 1px solid #e8eaec;
}

.theme-default .rules-list li::before {
  color: #333;
}

.theme-default .test-account {
  background: #f8f9fa;
}

.theme-default .notes {
  background: #ffffff;
  border-color: #ccc;
}

.theme-default .param-table th,
.theme-default .header-table th {
  background-color: #f2f2f2;
  border-color: #ddd;
}

.theme-default .param-table td,
.theme-default .header-table td {
  border-color: #ddd;
}

.theme-default .param-table tr:nth-child(even),
.theme-default .header-table tr:nth-child(even) {
  background-color: #f9f9f9;
}

.theme-default .api-footer {
  color: #999;
  border-top-color: #eee;
}

.theme-default code {
  background: #f2f2f2;
  color: #c7254e;
  padding: 2px 6px;
  border-radius: 3px;
}

.theme-default .key-link {
  color: #333;
}

/* ==================== 星空主题 (starry) - 默认 ==================== */
.theme-starry.api-doc-container {
  background: linear-gradient(135deg, #0f0f1a 0%, #1a1a2e 100%);
  color: #e2e8f0;
}

.theme-starry .api-header {
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
  border: 1px solid #2a2a3e;
}

.theme-starry .api-header h1 {
  color: #667eea;
  text-shadow: 0 0 20px rgba(102, 126, 234, 0.3);
}

.theme-starry .sidebar {
  background: #1a1a2e !important;
  border: 1px solid #2a2a3e;
}

.theme-starry .nav-list a {
  color: #a0aec0;
}

.theme-starry .nav-list a:hover {
  color: #667eea;
}

.theme-starry .content {
  background: #1a1a2e !important;
  border: 1px solid #2a2a3e;
}

.theme-starry .section {
  border-bottom-color: #2a2a3e;
}

.theme-starry .section h2 {
  color: #667eea;
  border-bottom: 1px solid #2a2a3e;
}

.theme-starry .rules-list li::before {
  color: #667eea;
}

.theme-starry .test-account {
  background: #16213e;
}

.theme-starry .notes {
  background: #16213e;
  border-color: #2a2a3e;
}

.theme-starry .param-table th,
.theme-starry .header-table th {
  background-color: #16213e;
  border-color: #2a2a3e;
  color: #667eea;
}

.theme-starry .param-table td,
.theme-starry .header-table td {
  border-color: #2a2a3e;
  color: #e2e8f0;
}

.theme-starry .param-table tr:nth-child(even),
.theme-starry .header-table tr:nth-child(even) {
  background-color: #0f0f1a;
}

.theme-starry .api-footer {
  color: #718096;
  border-top-color: #2a2a3e;
}

.theme-starry code {
  background: #16213e;
  color: #667eea;
  padding: 2px 6px;
  border-radius: 3px;
}

.theme-starry .key-link {
  color: #667eea;
}

/* ==================== 蓝色主题 (blue) ==================== */
.theme-blue.api-doc-container {
  background: linear-gradient(135deg, #E3F2FD 0%, #BBDEFB 100%);
  color: #1565C0;
}

.theme-blue .api-header {
  background: linear-gradient(135deg, #2196F3 0%, #1976D2 100%);
  border: none;
}

.theme-blue .api-header h1 {
  color: #ffffff;
}

.theme-blue .sidebar {
  background: #ffffff !important;
  border: 1px solid #90CAF9;
}

.theme-blue .nav-list a {
  color: #1565C0;
}

.theme-blue .nav-list a:hover {
  color: #0D47A1;
}

.theme-blue .content {
  background: #ffffff !important;
  border: 1px solid #90CAF9;
}

.theme-blue .section {
  border-bottom-color: #E3F2FD;
}

.theme-blue .section h2 {
  color: #1565C0;
  border-bottom: 1px solid #E3F2FD;
}

.theme-blue .rules-list li::before {
  color: #2196F3;
}

.theme-blue .test-account {
  background: #E3F2FD;
}

.theme-blue .notes {
  background: #E3F2FD;
  border-color: #90CAF9;
}

.theme-blue .param-table th,
.theme-blue .header-table th {
  background-color: #E3F2FD;
  border-color: #90CAF9;
  color: #1565C0;
}

.theme-blue .param-table td,
.theme-blue .header-table td {
  border-color: #90CAF9;
}

.theme-blue .param-table tr:nth-child(even),
.theme-blue .header-table tr:nth-child(even) {
  background-color: #E3F2FD;
}

.theme-blue .api-footer {
  color: #64B5F6;
  border-top-color: #BBDEFB;
  background: linear-gradient(135deg, #2196F3 0%, #1976D2 100%);
}

.theme-blue .api-footer p {
  color: #ffffff;
}

.theme-blue code {
  background: #E3F2FD;
  color: #1565C0;
  padding: 2px 6px;
  border-radius: 3px;
}

.theme-blue .key-link {
  color: #2196F3;
}

/* ==================== 紫色主题 (purple) ==================== */
.theme-purple.api-doc-container {
  background: linear-gradient(135deg, #F3E5F5 0%, #E1BEE7 100%);
  color: #6A1B9A;
}

.theme-purple .api-header {
  background: linear-gradient(135deg, #9C27B0 0%, #7B1FA2 100%);
  border: none;
}

.theme-purple .api-header h1 {
  color: #ffffff;
}

.theme-purple .sidebar {
  background: #ffffff !important;
  border: 1px solid #CE93D8;
}

.theme-purple .nav-list a {
  color: #6A1B9A;
}

.theme-purple .nav-list a:hover {
  color: #4A148C;
}

.theme-purple .content {
  background: #ffffff !important;
  border: 1px solid #CE93D8;
}

.theme-purple .section {
  border-bottom-color: #F3E5F5;
}

.theme-purple .section h2 {
  color: #6A1B9A;
  border-bottom: 1px solid #F3E5F5;
}

.theme-purple .rules-list li::before {
  color: #9C27B0;
}

.theme-purple .test-account {
  background: #F3E5F5;
}

.theme-purple .notes {
  background: #F3E5F5;
  border-color: #CE93D8;
}

.theme-purple .param-table th,
.theme-purple .header-table th {
  background-color: #F3E5F5;
  border-color: #CE93D8;
  color: #6A1B9A;
}

.theme-purple .param-table td,
.theme-purple .header-table td {
  border-color: #CE93D8;
}

.theme-purple .param-table tr:nth-child(even),
.theme-purple .header-table tr:nth-child(even) {
  background-color: #F3E5F5;
}

.theme-purple .api-footer {
  color: #CE93D8;
  border-top-color: #E1BEE7;
  background: linear-gradient(135deg, #9C27B0 0%, #7B1FA2 100%);
}

.theme-purple .api-footer p {
  color: #ffffff;
}

.theme-purple code {
  background: #F3E5F5;
  color: #6A1B9A;
  padding: 2px 6px;
  border-radius: 3px;
}

.theme-purple .key-link {
  color: #9C27B0;
}

/* ==================== 绿色主题 (green) ==================== */
.theme-green.api-doc-container {
  background: linear-gradient(135deg, #E8F5E9 0%, #C8E6C9 100%);
  color: #2E7D32;
}

.theme-green .api-header {
  background: linear-gradient(135deg, #4CAF50 0%, #388E3C 100%);
  border: none;
}

.theme-green .api-header h1 {
  color: #ffffff;
}

.theme-green .sidebar {
  background: #ffffff !important;
  border: 1px solid #A5D6A7;
}

.theme-green .nav-list a {
  color: #2E7D32;
}

.theme-green .nav-list a:hover {
  color: #1B5E20;
}

.theme-green .content {
  background: #ffffff !important;
  border: 1px solid #A5D6A7;
}

.theme-green .section {
  border-bottom-color: #E8F5E9;
}

.theme-green .section h2 {
  color: #2E7D32;
  border-bottom: 1px solid #E8F5E9;
}

.theme-green .rules-list li::before {
  color: #4CAF50;
}

.theme-green .test-account {
  background: #E8F5E9;
}

.theme-green .notes {
  background: #E8F5E9;
  border-color: #A5D6A7;
}

.theme-green .param-table th,
.theme-green .header-table th {
  background-color: #E8F5E9;
  border-color: #A5D6A7;
  color: #2E7D32;
}

.theme-green .param-table td,
.theme-green .header-table td {
  border-color: #A5D6A7;
}

.theme-green .param-table tr:nth-child(even),
.theme-green .header-table tr:nth-child(even) {
  background-color: #E8F5E9;
}

.theme-green .api-footer {
  border-top-color: #C8E6C9;
  background: linear-gradient(135deg, #4CAF50 0%, #388E3C 100%);
}

.theme-green .api-footer p {
  color: #ffffff;
}

.theme-green code {
  background: #E8F5E9;
  color: #2E7D32;
  padding: 2px 6px;
  border-radius: 3px;
}

.theme-green .key-link {
  color: #4CAF50;
}

/* ==================== 红色主题 (red) ==================== */
.theme-red.api-doc-container {
  background: linear-gradient(135deg, #FFEBEE 0%, #FFCDD2 100%);
  color: #C62828;
}

.theme-red .api-header {
  background: linear-gradient(135deg, #F44336 0%, #D32F2F 100%);
  border: none;
}

.theme-red .api-header h1 {
  color: #ffffff;
}

.theme-red .sidebar {
  background: #ffffff !important;
  border: 1px solid #EF9A9A;
}

.theme-red .nav-list a {
  color: #C62828;
}

.theme-red .nav-list a:hover {
  color: #B71C1C;
}

.theme-red .content {
  background: #ffffff !important;
  border: 1px solid #EF9A9A;
}

.theme-red .section {
  border-bottom-color: #FFEBEE;
}

.theme-red .section h2 {
  color: #C62828;
  border-bottom: 1px solid #FFEBEE;
}

.theme-red .rules-list li::before {
  color: #F44336;
}

.theme-red .test-account {
  background: #FFEBEE;
}

.theme-red .notes {
  background: #FFEBEE;
  border-color: #EF9A9A;
}

.theme-red .param-table th,
.theme-red .header-table th {
  background-color: #FFEBEE;
  border-color: #EF9A9A;
  color: #C62828;
}

.theme-red .param-table td,
.theme-red .header-table td {
  border-color: #EF9A9A;
}

.theme-red .param-table tr:nth-child(even),
.theme-red .header-table tr:nth-child(even) {
  background-color: #FFEBEE;
}

.theme-red .api-footer {
  border-top-color: #FFCDD2;
  background: linear-gradient(135deg, #F44336 0%, #D32F2F 100%);
}

.theme-red .api-footer p {
  color: #ffffff;
}

.theme-red code {
  background: #FFEBEE;
  color: #C62828;
  padding: 2px 6px;
  border-radius: 3px;
}

.theme-red .key-link {
  color: #F44336;
}

/* ==================== 橙色主题 (orange) ==================== */
.theme-orange.api-doc-container {
  background: linear-gradient(135deg, #FFF3E0 0%, #FFE0B2 100%);
  color: #E65100;
}

.theme-orange .api-header {
  background: linear-gradient(135deg, #FF9800 0%, #F57C00 100%);
  border: none;
}

.theme-orange .api-header h1 {
  color: #ffffff;
}

.theme-orange .sidebar {
  background: #ffffff !important;
  border: 1px solid #FFCC80;
}

.theme-orange .nav-list a {
  color: #E65100;
}

.theme-orange .nav-list a:hover {
  color: #BF360C;
}

.theme-orange .content {
  background: #ffffff !important;
  border: 1px solid #FFCC80;
}

.theme-orange .section {
  border-bottom-color: #FFF3E0;
}

.theme-orange .section h2 {
  color: #E65100;
  border-bottom: 1px solid #FFF3E0;
}

.theme-orange .rules-list li::before {
  color: #FF9800;
}

.theme-orange .test-account {
  background: #FFF3E0;
}

.theme-orange .notes {
  background: #FFF3E0;
  border-color: #FFCC80;
}

.theme-orange .param-table th,
.theme-orange .header-table th {
  background-color: #FFF3E0;
  border-color: #FFCC80;
  color: #E65100;
}

.theme-orange .param-table td,
.theme-orange .header-table td {
  border-color: #FFCC80;
}

.theme-orange .param-table tr:nth-child(even),
.theme-orange .header-table tr:nth-child(even) {
  background-color: #FFF3E0;
}

.theme-orange .api-footer {
  border-top-color: #FFE0B2;
  background: linear-gradient(135deg, #FF9800 0%, #F57C00 100%);
}

.theme-orange .api-footer p {
  color: #ffffff;
}

.theme-orange code {
  background: #FFF3E0;
  color: #E65100;
  padding: 2px 6px;
  border-radius: 3px;
}

.theme-orange .key-link {
  color: #FF9800;
}
</style>

<style>
/* ==================== 全局 body 背景（非 scoped，确保穿透） ==================== */
body.theme-default {
  background: #f5f7fa !important;
}

body.theme-starry {
  background: linear-gradient(135deg, #0f0f1a 0%, #1a1a2e 100%) !important;
}

body.theme-blue {
  background: linear-gradient(135deg, #E3F2FD 0%, #BBDEFB 100%) !important;
}

body.theme-purple {
  background: linear-gradient(135deg, #F3E5F5 0%, #E1BEE7 100%) !important;
}

body.theme-green {
  background: linear-gradient(135deg, #E8F5E9 0%, #C8E6C9 100%) !important;
}

body.theme-red {
  background: linear-gradient(135deg, #FFEBEE 0%, #FFCDD2 100%) !important;
}

body.theme-orange {
  background: linear-gradient(135deg, #FFF3E0 0%, #FFE0B2 100%) !important;
}
</style>
